// extracted by mini-css-extract-plugin
export var form = "_f1-0";